// import request from './request'

// // 用户登录
// export function datalist(data) {
//   return request({
//     url: 'https://106.3.97.131:82/api.php?c=news&f=news_list',
//     method: 'post',
//     header: {
//       'Content-Type':'application/json;charset=UTF-8'  
//   },
//     data
//   })
// }
import axios from 'axios'




// export const datalist = params => axios.post('http://106.3.97.131:82/api.php?c=news&f=news_list', params)
export const datalist = params => axios.post('http://sadmin.sishoe.com/api.php?c=news&f=news_list', params)


